import apiClient from './client'

/**
 * Массовые действия и удаления Штаба, ждущие подтверждения (S14, SC08).
 * Подтверждение исполняется на сервере ровно один раз: повтор запроса, второе
 * устройство или нажатие в боте возвращают сохранённый итог с replayed: true.
 */

export type AiActionStatus = 'pending' | 'executing' | 'executed' | 'cancelled' | 'expired' | 'failed'

export interface AiActionDTO {
  id: string
  tool: string
  status: AiActionStatus
  /** У failed: stale, forbidden, interrupted, error */
  error_code?: string
  title: string
  summary: string
  confirm_label: string
  items: { label: string; before: string; after: string }[] | null
  target?: {
    kind: string
    id: string
    label: string
    date?: string
    start_time?: string
    year_month?: string
  }
  /** Последствия, которых не видно из списка (у удалений - что скроется и можно ли вернуть). */
  note?: string
  /** Удаление или другое опасное действие: кнопка подтверждения - опасная. */
  danger?: boolean
  result?: {
    summary: string
    done: { label: string; detail?: string }[] | null
    failed: { label: string; detail?: string }[] | null
  }
  source_channel?: 'web' | 'telegram' | 'max'
  resolved_channel?: 'web' | 'telegram' | 'max'
  created_at: string
  expires_at: string
  resolved_at?: string
  /** Только у confirm и cancel: этот вызов ничего не изменил. */
  replayed: boolean
}

export const aiActionsApi = {
  /** GET /api/v1/ai-actions/{id} */
  get: async (id: string): Promise<AiActionDTO> => {
    const response = await apiClient.get<AiActionDTO>(`/ai-actions/${id}`)
    return response.data
  },

  /** POST /api/v1/ai-actions/{id}/confirm - исполнить ровно один раз. */
  confirm: async (id: string): Promise<AiActionDTO> => {
    const response = await apiClient.post<AiActionDTO>(`/ai-actions/${id}/confirm`)
    return response.data
  },

  /** POST /api/v1/ai-actions/{id}/cancel */
  cancel: async (id: string): Promise<AiActionDTO> => {
    const response = await apiClient.post<AiActionDTO>(`/ai-actions/${id}/cancel`)
    return response.data
  },
}
